module.exports = __webpack_public_path__ + "img/GTRUMP[GalaChainAllowance]-icon.aa5f6bf.png";